import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { ROUTES } from "~/const/route";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { AppBar, Toolbar, Button } from "@material-ui/core";
import { logoutSpecialist } from "~/redux/modules/specialist/auth";
import { RootState } from "~/redux/rootReducer";

export const Header: React.VFC = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  // global state
  const login = useSelector((state: RootState) => state.specialistAuth.login);

  // ログアウト
  const onClickLogout = async () => {
    await dispatch(logoutSpecialist());
    history.push(ROUTES.SPECIALIST.LOGOUT);
  };

  return (
    <AppBar className={classes.appBar} position="fixed">
      <Toolbar>
        <Link
          className={classes.appBarTitle}
          to={login ? ROUTES.SPECIALIST.HOME : ROUTES.SPECIALIST.LOGIN}
        >
          <h3 className={classes.appBarTitleText}>
            SHUZO/専門家情報登録サイト
          </h3>
        </Link>
        <a
          className={classes.link}
          href="https://drive.google.com/file/d/1Hub9h3wyQL_x9QxknaICh36P9Q1kDeH1/view?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button color="inherit">利用規約</Button>
        </a>
        <a
          className={classes.link}
          href="https://drive.google.com/file/d/1arQrGRzN35EAPgZMZeRPWC4dkpRZTBRk/view?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button color="inherit">登録専門家規約</Button>
        </a>
        <a
          className={classes.link}
          href="https://drive.google.com/file/d/1s8YgCkOF52SsP9N51uLkOjcoHcot8TtK/view?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button color="inherit">個人情報保護方針</Button>
        </a>
        <a
          className={classes.link}
          href="https://docs.google.com/forms/d/e/1FAIpQLSeNUYFqQxp01p1FtJNaympJC3P8jFpC-uxSdNPWlyFgBg-HYQ/viewform?usp=sf_link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button color="inherit">お問い合わせ</Button>
        </a>
        {login && (
          <Button onClick={onClickLogout} color="inherit">
            ログアウト
          </Button>
        )}
      </Toolbar>
    </AppBar>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
    },
    appBarTitle: {
      flexGrow: 1,
      fontSize: 20,
      color: "#fff",
      textDecoration: "none",
    },
    appBarTitleText: {
      margin: 0,
    },
    link: {
      color: "#fff",
      textDecoration: "none",
      marginRight: 10,
    },
  })
);
